import { DescriptionList, ProductTable } from '@vwfs-bronson/bronson-react';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

export const RenderNonServicePlanAppplicationSummary: FunctionComponent = () => {
  const { t } = useTranslation();
  return (
    <ProductTable>
      <ProductTable.Section>
        <DescriptionList split>
          <DescriptionList.Group termText={t('applicationSummary:productTable:rentalProfile')}>
            <DescriptionList.Detail>3+33</DescriptionList.Detail>
          </DescriptionList.Group>
          <DescriptionList.Group termText={t('applicationSummary:productTable:duration')}>
            <DescriptionList.Detail>36</DescriptionList.Detail>
          </DescriptionList.Group>
          <DescriptionList.Group termText={t('applicationSummary:productTable:distance')}>
            <DescriptionList.Detail>20,000km</DescriptionList.Detail>
          </DescriptionList.Group>
          <DescriptionList.Group termText={t('applicationSummary:productTable:recommendedPriceVehicle')}>
            <DescriptionList.Detail>€24,120.29</DescriptionList.Detail>
          </DescriptionList.Group>
          <DescriptionList.Group termText={t('applicationSummary:productTable:recommendedPriceOptions')}>
            <DescriptionList.Detail>€0.00</DescriptionList.Detail>
          </DescriptionList.Group>
          <DescriptionList.Group termText={t('applicationSummary:productTable:recommendedPriceAccessories')}>
            <DescriptionList.Detail>€0.00</DescriptionList.Detail>
          </DescriptionList.Group>
        </DescriptionList>
      </ProductTable.Section>
      <ProductTable.Section>
        <DescriptionList split>
          <DescriptionList.Group termText={t('applicationSummary:productTable:vpo')}>
            <DescriptionList.Detail>€36,039.96</DescriptionList.Detail>
          </DescriptionList.Group>
          <DescriptionList.Group termText={t('applicationSummary:productTable:monthlyPayment')}>
            <DescriptionList.Detail>€6347.79</DescriptionList.Detail>
          </DescriptionList.Group>
        </DescriptionList>
      </ProductTable.Section>
    </ProductTable>
  );
};
